import { useEffect } from 'react';

const LEAK_RE =
  /oaiq\s*\(\s*["']measure["']|page_viewed|main\s*\(\s*measure|gtag\s*\(\s*["']measure["']/i;

function isLeakText(value) {
  const text = (value || '').trim();
  if (!text) return false;
  return LEAK_RE.test(text) && text.length < 200;
}

function scrubNode(root) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const doomed = [];

  let node = walker.nextNode();
  while (node) {
    if (isLeakText(node.textContent)) {
      doomed.push(node);
    }
    node = walker.nextNode();
  }

  doomed.forEach((text) => {
    const parent = text.parentElement;
    if (
      parent &&
      parent.childNodes.length === 1 &&
      parent.tagName !== 'SCRIPT' &&
      parent.tagName !== 'STYLE' &&
      parent.tagName !== 'NOSCRIPT'
    ) {
      parent.remove();
    } else {
      text.remove();
    }
  });
}

export const HideTrackingDebug = () => {
  useEffect(() => {
    scrubNode(document.body);

    const observer = new MutationObserver(() => scrubNode(document.body));
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    const t1 = window.setTimeout(() => scrubNode(document.body), 500);
    const t2 = window.setTimeout(() => scrubNode(document.body), 2000);

    return () => {
      observer.disconnect();
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, []);

  return null;
};
